import { IStudent, StudentField } from '@studyportals/studentdomain';
import { StudentClient } from '../infrastructure/student-client';

export class StudentRepository {
	private studentClient: StudentClient;
	private fullProfileScope: StudentField[];

	constructor(studentClient: StudentClient) {
		this.studentClient = studentClient;

		this.fullProfileScope = [
			StudentField.EMAIL,
			StudentField.NAME,
			StudentField.GENDER,
			StudentField.BIRTH_DATE,
			StudentField.NATIONALITY_COUNTRY_ID,
			StudentField.RESIDENCE_COUNTRY_ID,
			StudentField.INTERESTS_DISCIPLINES,
			StudentField.INTERESTS_COUNTRIES,
			StudentField.START_PERIOD_DATE,
			StudentField.TUITION_BUDGET,
			StudentField.LIVING_BUDGET,
			StudentField.STUDY_LEVEL,
			StudentField.STUDY_COUNTRY_ID,
			StudentField.ORIGIN_ORGANISATION_ID,
			StudentField.DISCIPLINES,
			StudentField.GPA,
			StudentField.WORK_EXPERIENCE,
			StudentField.PROFICIENCY_TYPE,
		];
	}

	public async getFields(fields: StudentField[]): Promise<IStudent | null> {
		return await this.studentClient.getData(fields);
	}

	public async setData(studentData: IStudent): Promise<void> {
		await this.studentClient.saveStudentData(studentData);
	}

	public async getCompleteness(fields: StudentField[] = this.fullProfileScope): Promise<number> {
		if (fields.length === 0) {
			return 100;
		}

		return Math.ceil((await this.studentClient.getCompleteness(fields)) * 100);
	}
}
